"use client";
import BottomButton from "@/app/(main)/_components/BottomButton";
import Category2Icon from "@/app/_components/Icons/Category2Icon";
import Category2BoldIcon from "@/app/_components/Icons/Category2BoldIcon";
import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Grow,
  Icon,
  IconButton,
  LinearProgress,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import { Close, Send } from "@mui/icons-material";
import { useSiteSearchContext } from "@/app/(main)/_components/SITESEARCH/SiteSearchContext";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";
import { useGqlClient } from "@/Providers/GQLProvider";
import { generateRecursiveHrefs } from "@/app/(main)/categories/[...slugs]/generateRecursiveHrefs";
import { CategoryDto } from "@/__generated__/sdk";
import Image from "next/image";
import DOMPurify from "isomorphic-dompurify";
import { CategoryDtoWithHref } from "@/app/(main)/_components/SITESEARCH/SearchSideFilters/types/CategoryDtoWithHref";
import ArrowLeftIcon from "@/app/_components/Icons/ArrowLeftIcon";
import NextLink from "next/link";

function CatLists({ handleClose }: { handleClose: () => void }) {
  const [active, setActive] = useState<Number>(0);
  const gqlClient = useGqlClient();
  const { data: menu, isFetching } = useQuery({
    queryKey: [gqlClient.menu.name],
    queryFn: () => {
      return gqlClient.menu();
    },
  });
  const categories = menu && menu.menu ? generateRecursiveHrefs("/categories", menu.menu as CategoryDto[], 1) : [];
  const activeCat: CategoryDtoWithHref | undefined = useMemo(() => {
    return categories.find((a, i) => i === active);
  }, [categories, active]);
  return (
    <>
      <Box sx={{ display: "flex", p: 0, overflowY: "auto", flexGrow: 1, alignItems: "start" }}>
        <Stack width={"100%"} spacing={1} height={"100%"} direction="row" useFlexGap sx={{ flexWrap: "nowrap" }}>
          <Stack
            sx={{
              backgroundColor: "grey.50",
              overflow: "auto",
              // borderTopRightRadius: 4 * 3
            }}
            className={"custom-scrollbar"}
            height={"100%"}
            minWidth={"max-content"}
          >
            <List disablePadding={true}>
              {categories.map((parent, i) => {
                const selected = i === active;
                return (
                  <ListItemButton
                    onClick={() => {
                      setActive(i);
                    }}
                    sx={{
                      backgroundColor: selected ? "grey.900" : "inherit",
                      color: selected ? "white.main" : "grey.700",
                      "&:hover": {
                        backgroundColor: selected ? "grey.800" : "inherit",
                      },
                      borderBottom: 1,
                      borderColor: "grey.400",
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: "30px", color: "inherit" }}>
                      {parent.svg && (
                        <Icon
                          sx={{
                            width: "22px !important",
                            height: "22px !important",
                            display: "flex",
                            color: "inherit",
                            alignItems: "center",
                            justifyContent: "center",
                            "& svg": { width: "22px !important", height: "22px !important" },
                          }}
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parent.svg) }}
                        ></Icon>
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant={"subtitle1"} fontWeight={700}>
                          {parent.title}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                );
              })}
            </List>
          </Stack>
          <Stack
            sx={{ overflowY: "auto", pb: 3, pr: 1 }}
            display={"flex"}
            flexDirection={"column"}
            className={"custom-scrollbar"}
            height={"100%"}
            width={"100%"}
            alignItems={"start"}
          >
            {activeCat && (
              <>
                <Button
                  component={NextLink}
                  href={activeCat.href}
                  onClick={() => {
                    handleClose();
                  }}
                  endIcon={
                    <Icon>
                      <ArrowLeftIcon />
                    </Icon>
                  }
                  color={"secondary"}
                >
                  مشاهده همه {activeCat.title}
                </Button>
                <List sx={{ width: "100%" }}>
                  {activeCat.children?.map((sub, index) => {
                    return (
                      <ListItemButton
                        key={index}
                        component={NextLink}
                        href={sub.href}
                        sx={{ borderRadius: 3 }}
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        <ListItemText primary={<Typography variant={"body1"}>{sub.title}</Typography>} />
                      </ListItemButton>
                    );
                  })}
                </List>
              </>
            )}
          </Stack>
        </Stack>
      </Box>
    </>
  );
}

export default function BottomBarCategories() {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <BottomButton
        label="دسته بندی"
        icon={<Category2Icon />}
        selected={open}
        boldIcon={<Category2BoldIcon />}
        onClick={() => {
          setOpen(true);
        }}
      />

      <SwipeableDrawer
        ModalProps={{
          keepMounted: false,
        }}
        PaperProps={{
          sx: {
            height: "70vh",
            borderTopLeftRadius: 4 * 4,
            borderTopRightRadius: 4 * 4,
          },
        }}
        anchor={"bottom"}
        open={open}
        onClose={() => {
          handleClose();
        }}
        onOpen={() => {}}
        disableDiscovery={true}
        hysteresis={0}
        disableSwipeToOpen={true}
        swipeAreaWidth={0}
      >
        <Stack sx={{ height: "100%", flexGrow: 1 }}>
          <Stack direction={"row"} sx={{ mt: 1, flexShrink: 0 }} alignItems={"center"} justifyContent={"center"}>
            <Box width={"45px"} height={"5px"} sx={{ borderRadius: 50, backgroundColor: "grey.100" }}></Box>
          </Stack>
          <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
            <Typography variant="h4"> انتخاب دسته بندی </Typography>
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <CatLists handleClose={handleClose} />
        </Stack>
      </SwipeableDrawer>
    </>
  );
}
